var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ButtonBack',{staticClass:"mb_m"}),_c('input-name'),_c('input-branch-name'),_c('input-account-type'),_c('input-account-number'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }